import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

interface DeleteDiaryModalProps {
    showModal: boolean;
    title: string;
    onCancel: () => void;
    onConfirm: (choice: "selected" | "entire") => void;
}

const DeleteDiaryConfirmationModal: React.FC<DeleteDiaryModalProps> = ({
    showModal,
    title,
    onCancel,
    onConfirm,
}) => {
    const [deleteChoice, setDeleteChoice] = useState<"selected" | "entire">("selected");

    useEffect(() => {
        if (showModal) setDeleteChoice("selected");
    }, [showModal]);

    const confirmModalPopup = (action: "cancel" | "confirm") => {
        if (action === "cancel") {
            onCancel();
        } else if (action === "confirm") {
            onConfirm(deleteChoice);
        }
    };

    return (
        <Modal show={showModal} onHide={onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Delete diary item(s)?</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="d-flex align-items-center">
                    <div className="form-check" style={{ marginRight: "3rem" }}>
                        <input
                            type="radio"
                            className="form-check-input"
                            id="deleteSelected"
                            name="deleteOption"
                            value="selected"
                            checked={deleteChoice === "selected"}
                            onChange={() => setDeleteChoice("selected")}
                        />
                        <label className="form-check-label ms-1" htmlFor="deleteSelected">
                            <span style={{ marginLeft: "6px" }}><strong>Only selected diary item</strong></span>
                        </label>
                    </div>

                    <div className="form-check">
                        <input
                            type="radio"
                            className="form-check-input"
                            id="deleteEntire"
                            name="deleteOption"
                            value="entire"
                            checked={deleteChoice === "entire"}
                            onChange={() => setDeleteChoice("entire")}
                        />
                        <label className="form-check-label ms-1" htmlFor="deleteEntire">
                            <span style={{ marginLeft: "6px" }}><strong>All recurring diary items</strong></span>
                        </label>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button onClick={() => confirmModalPopup("cancel")}>Cancel</Button>
                <Button bsStyle="primary" onClick={() => confirmModalPopup("confirm")}>
                    Confirm
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteDiaryConfirmationModal;
